import { accreditationsService } from 'hq/services';
import { useMutation, useQueryClient } from 'react-query';
import { DateTime } from 'luxon';
import { QUERY_KEYS } from 'api/query-keys';
import { AccreditationFormRepresentation } from '../../../../../shared/utils/file-handling/file-handling-utils.types';
import { AccreditationType } from '../../../../services/accreditations-service.types';

export type UpdateAccreditationParams = {
  flexWorkerId: string;
  certificateId: string;
  expirationDate: DateTime | null;
  startDate: DateTime | null;
  accreditationType: AccreditationType;
  accreditations?: AccreditationFormRepresentation[];
};

export const useUpdateAccreditation = () => {
  const mutationFn = async ({
    flexWorkerId,
    certificateId,
    expirationDate,
    startDate,
    accreditations,
    accreditationType,
  }: UpdateAccreditationParams) =>
    await accreditationsService.updateAccreditation(
      flexWorkerId,
      certificateId,
      expirationDate,
      startDate,
      accreditationType,
      accreditations
    );
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.accreditations());
    },
  });
};
